{
  "familyId": "REK-CIJF-DEEL",
  "questions": [
    {
      "id": "REK-CIJF-DEEL-001",
      "familyId": "REK-CIJF-DEEL",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "cijferend",
      "subSkill": "cijferend_delen",
      "questionType": "cijferend_delen",
      "question": "Reken uit: 96 ÷ 4",
      "options": [],
      "correctAnswer": "24",
      "data": {
        "acceptedAnswers": ["24"],
        "operand1": 96,
        "operand2": 4
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Staartdeling: per cijfer",
            "content": "96 ÷ 4: begin links. 9 ÷ 4 = 2 (rest 1). Haal de 6 naar beneden → 16. 16 ÷ 4 = 4. Antwoord: 24. Tip: werk van links naar rechts, neem steeds de rest mee.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_deel_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "96 ÷ 4 = 24. Staartdeling: 9 ÷ 4 = 2 (rest 1). Haal de 6 naar beneden → 16. 16 ÷ 4 = 4. Antwoord: 24. Bij staartdeling werk je van links naar rechts en neem je de rest steeds mee naar het volgende cijfer.",
        "solutionSteps": [
          "9 ÷ 4 = 2, rest 1",
          "Haal 6 naar beneden → 16",
          "16 ÷ 4 = 4",
          "Antwoord: 24"
        ]
      }
    },
    {
      "id": "REK-CIJF-DEEL-002",
      "familyId": "REK-CIJF-DEEL",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "cijferend",
      "subSkill": "cijferend_delen",
      "questionType": "cijferend_delen",
      "question": "Reken uit: 738 ÷ 6",
      "options": ["123", "132", "113", "128"],
      "correctAnswer": 0,
      "data": {
        "operand1": 738,
        "operand2": 6
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Staartdeling met driecijferig getal",
            "content": "738 ÷ 6: 7 ÷ 6 = 1 (rest 1). Haal 3 naar beneden → 13. 13 ÷ 6 = 2 (rest 1). Haal 8 naar beneden → 18. 18 ÷ 6 = 3. Antwoord: 123.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_deel_3cijferig",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "738 ÷ 6 = 123. Staartdeling: 7 ÷ 6 = 1 (rest 1). Haal 3 naar beneden → 13. 13 ÷ 6 = 2 (rest 1). Haal 8 naar beneden → 18. 18 ÷ 6 = 3. Antwoord: 123.",
        "solutionSteps": [
          "7 ÷ 6 = 1, rest 1",
          "Haal 3 naar beneden → 13 ÷ 6 = 2, rest 1",
          "Haal 8 naar beneden → 18 ÷ 6 = 3",
          "Antwoord: 123"
        ],
        "distractorExplanations": {
          "0": "Goed! 738 ÷ 6 = 123. Netjes stap voor stap gedeeld.",
          "1": "Je verwisselde waarschijnlijk de cijfers: 123, niet 132. Controleer: 132 × 6 = 792 ≠ 738. Maar 123 × 6 = 738. ✓",
          "2": "Je dacht waarschijnlijk 13 ÷ 6 = 1 in plaats van 2. 13 ÷ 6 = 2 (rest 1), want 6 × 2 = 12. Antwoord: 123, niet 113.",
          "3": "Je dacht waarschijnlijk 18 ÷ 6 = 8 in plaats van 3. Maar 18 ÷ 6 = 3 (niet 8). Controleer: 6 × 3 = 18. ✓ Antwoord: 123."
        }
      }
    },
    {
      "id": "REK-CIJF-DEEL-003",
      "familyId": "REK-CIJF-DEEL",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "cijferend",
      "subSkill": "cijferend_delen",
      "questionType": "cijferend_delen",
      "question": "Reken uit: 475 ÷ 5",
      "options": [],
      "correctAnswer": "95",
      "data": {
        "acceptedAnswers": ["95"],
        "operand1": 475,
        "operand2": 5
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen door 5: let op het eerste cijfer",
            "content": "475 ÷ 5: 4 ÷ 5 = 0 (4 is kleiner dan 5!). Neem 47: 47 ÷ 5 = 9 (rest 2). Haal 5 naar beneden → 25. 25 ÷ 5 = 5. Antwoord: 95. Let op: als het eerste cijfer kleiner is dan de deler, neem je twee cijfers samen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_deel_eerste_kleiner",
      "variantIndex": 3,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "475 ÷ 5 = 95. Let op: 4 is kleiner dan 5, dus neem twee cijfers samen. 47 ÷ 5 = 9 (rest 2). Haal 5 naar beneden → 25. 25 ÷ 5 = 5. Antwoord: 95. Dit is een veelgemaakte fout: als het eerste cijfer kleiner is dan de deler, krijg je een antwoord met minder cijfers.",
        "solutionSteps": [
          "4 < 5, dus neem 47",
          "47 ÷ 5 = 9, rest 2",
          "Haal 5 naar beneden → 25 ÷ 5 = 5",
          "Antwoord: 95"
        ]
      }
    },
    {
      "id": "REK-CIJF-DEEL-004",
      "familyId": "REK-CIJF-DEEL",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "cijferend",
      "subSkill": "cijferend_delen",
      "questionType": "cijferend_delen",
      "question": "Een bloemist verdeelt 258 tulpen gelijk over 6 vazen. Hoeveel tulpen komen er in elke vaas?",
      "options": ["43", "42", "44", "48"],
      "correctAnswer": 0,
      "data": {
        "operand1": 258,
        "operand2": 6
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen = gelijk verdelen",
            "content": "258 ÷ 6: 25 ÷ 6 = 4 (rest 1). Haal 8 naar beneden → 18. 18 ÷ 6 = 3. Antwoord: 43 tulpen per vaas. Controleer: 43 × 6 = 258. ✓",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_deel_context",
      "variantIndex": 4,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "258 ÷ 6 = 43. Staartdeling: 2 < 6, dus neem 25. 25 ÷ 6 = 4 (rest 1). Haal 8 naar beneden → 18. 18 ÷ 6 = 3. Elke vaas krijgt 43 tulpen. Controleer: 43 × 6 = 258. ✓",
        "solutionSteps": [
          "Herken: 258 tulpen ÷ 6 vazen",
          "25 ÷ 6 = 4, rest 1",
          "Haal 8 naar beneden → 18 ÷ 6 = 3",
          "Antwoord: 43 tulpen per vaas"
        ],
        "distractorExplanations": {
          "0": "Goed! 258 ÷ 6 = 43 tulpen per vaas.",
          "1": "Je dacht waarschijnlijk 252 ÷ 6 = 42. Maar het getal is 258, niet 252. 258 ÷ 6 = 43. Controleer: 43 × 6 = 258. ✓",
          "2": "Je dacht waarschijnlijk 264 ÷ 6 = 44. Maar het getal is 258, niet 264. 258 ÷ 6 = 43.",
          "3": "Je dacht waarschijnlijk 288 ÷ 6 = 48. Maar het getal is 258, niet 288. 258 ÷ 6 = 43."
        }
      }
    },
    {
      "id": "REK-CIJF-DEEL-005",
      "familyId": "REK-CIJF-DEEL",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "cijferend",
      "subSkill": "cijferend_delen",
      "questionType": "cijferend_delen",
      "question": "Reken uit: 847 ÷ 7",
      "options": ["121", "112", "127", "131"],
      "correctAnswer": 0,
      "data": {
        "operand1": 847,
        "operand2": 7
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Staartdeling: stap voor stap",
            "content": "847 ÷ 7: 8 ÷ 7 = 1 (rest 1). Haal 4 naar beneden → 14. 14 ÷ 7 = 2. Haal 7 naar beneden → 7. 7 ÷ 7 = 1. Antwoord: 121. Controleer: 121 × 7 = 847. ✓",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_deel_3cijferig_complex",
      "variantIndex": 5,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "847 ÷ 7 = 121. Staartdeling: 8 ÷ 7 = 1 (rest 1). Haal 4 naar beneden → 14 ÷ 7 = 2. Haal 7 naar beneden → 7 ÷ 7 = 1. Antwoord: 121. Controleer altijd je antwoord: 121 × 7 = 847. ✓",
        "solutionSteps": [
          "8 ÷ 7 = 1, rest 1",
          "Haal 4 naar beneden → 14 ÷ 7 = 2",
          "Haal 7 naar beneden → 7 ÷ 7 = 1",
          "Antwoord: 121"
        ],
        "distractorExplanations": {
          "0": "Goed! 847 ÷ 7 = 121. Netjes stap voor stap.",
          "1": "Je verwisselde waarschijnlijk de cijfers: 121, niet 112. Controleer: 112 × 7 = 784 ≠ 847. Maar 121 × 7 = 847. ✓",
          "2": "Je dacht waarschijnlijk 14 ÷ 7 = 7 in plaats van 2. Maar 14 ÷ 7 = 2 (want 7 × 2 = 14). Antwoord: 121, niet 127.",
          "3": "Je dacht waarschijnlijk 8 ÷ 7 = 1 (rest 1), dan 14 ÷ 7 = 3. Maar 14 ÷ 7 = 2 (want 7 × 2 = 14, niet 7 × 3 = 21). Antwoord: 121."
        }
      }
    }
  ]
}